import { Api } from './Api'

const providersPathTo = {
  get: (options) => {
    return Api.request({
      url: '/public/providers/' + options.id + '.json',
      method: 'get',
      params: options.params
    })
  },
  list: (options = {}) => {
    return Api.request({
      url: '/public/providers.json',
      method: 'get',
      params: options.params,
    })
  },
  update: (id, data) => {
    return Api.request({
      url: '/providers/' + id + '.json',
      method: 'put',
      data: { provider: data }
    })
  },
  update_logo_image: (id, data) => {
    return Api.request({
      url: '/providers/' + id + '/update_logo_image.json',
      method: 'put',
      data: { provider: data }
    })
  },
  update_banner_image: (id, data) => {
    return Api.request({
      url: '/providers/' + id + '/update_banner_image.json',
      method: 'put',
      data: { provider: data }
    })
  },
  provider_with_products: (options) => {
    return Api.request({
      url: '/public/providers/' + options.id + '/provider_with_products.json',
      method: 'get',
      params: options.params
    })
  },
  save: (data) => {
    return Api.request({
      url: '/providers.json',
      method: 'post',
      data: { provider: data }
    })
  },
  stripe_account_onboarding: (id) => {
    return Api.request({
      url: `/providers/${id}/stripe_account_onboarding.json`,
      method: 'get'
    })
  },
  stripe_account_session: (id) => {
    return Api.request({
      url: `/providers/${id}/stripe_account_session.json`,
      method: 'get'
    })
  },
  update_published: (id, data) => {
    return Api.request({
      url: `/providers/${id}/update_published.json`,
      method: 'put',
      data: { provider: data }
    })
  },
}

export default providersPathTo